export const NAME: string = "page-public-notification";
